import Vue from "vue";
import App from "./App.vue";
import router from "./router"; //router要到上面
import store from "./store";
import common from "@/assets/js/common";
import cm from "@/assets/js/cm";
import VTooltip from "v-tooltip";


Vue.use(VTooltip);

import "@/assets/css/newElenemtUi.css";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/css/main.scss";
import "@/assets/css/reset.css";
import "@/assets/css/tailwind-isolated.css"

import { message } from "@/assets/js/message.js";
import preventReClick from "@/assets/js/directive.js";
Vue.use(preventReClick);

import APIPHP from "@/api/index.php"; // 接口配置
import APIJAVA from "@/api/index.java"; // 接口配置
import APIPY from "@/api/index.python"; // 接口配置
import GLOBAL_VARIABLE from "@/api/global_variable"; //全局变量
import VueCookies from "vue-cookies";

export const EventBus = new Vue();

Vue.use(ElementUI);
Vue.use(VueCookies);

Vue.prototype.validForbid = function(value, number = 255) {
  value = value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g, "").replace(/\s/g, "");
  return value;
};

Vue.prototype.$layer = window.layer;
Vue.prototype.$common = common;
Vue.prototype.$cm = cm;
//请求接口
Vue.prototype.$APIPHP = APIPHP;
Vue.prototype.$APIJAVA = APIJAVA;
Vue.prototype.$APIPY = APIPY;

Vue.prototype.$GLOBAL_VARIABLE = GLOBAL_VARIABLE;
Vue.prototype.$message = message;
Vue.prototype.$cookies = VueCookies;

Vue.config.productionTip = false;

// 自定义指令 - 只能输入0-9的数字
Vue.directive("numberonly", {
  update: function(el) {
    el.onkeypress = function(e) {
      var code = e.charCode;
      if (code != 0) {
        if (!String.fromCharCode(code).match(/[0-9\.]/)) {
          return false;
        }
      }
    };
    el.addEventListener("textInput", function(e) {
      e.target.value = e.target.value.replace(/[^0-9\.]/g, "");
    });
    el.onkeyup = function(e) {
      e.target.value = e.target.value.replace(/[^0-9\.]/g, "");
    };
  },
});

new Vue({
  router,
  store,
  metaInfo() {
    return {
      title: this.$store.state.metaInfo.title,
      meta: [
        {
          name: "keywords",
          content: this.$store.state.metaInfo.keywords,
        },
        {
          name: "description",
          content: this.$store.state.metaInfo.description,
        },
      ],
    };
  },
  render: h => h(App),
}).$mount("#app");
